import { getStore, setStore, removeStore } from './sessionStorage';

/**
 * 设置当前登录用户的信息 
 */
export function setUser(loginData) {
  setStore("LOGIN_USER", loginData);
  setStore("LOGIN_USERID", loginData.id);
  setStore("LOGIN_USERNAME", loginData.name);
  setStore("LOGIN_SUPERUSER", loginData.superUser);
  setStore("LOGIN_MENULIST", loginData.menus);
  setStore("AUTH_TOKEN", loginData.token);
  setStore("CHAIN", loginData.chain);
}

export function clearUser() {
  removeStore("LOGIN_USER");
  removeStore("LOGIN_USERID");
  removeStore("LOGIN_USERNAME");
  removeStore("LOGIN_SUPERUSER");
  removeStore("LOGIN_MENULIST");
  removeStore("AUTH_TOKEN");
  removeStore("CHAIN");
}
export function getUser() {
  return getStore("LOGIN_USER");
}
export function getUserName() {
  return getStore("LOGIN_USERNAME");
}
export function isSuperUser() {
    return getStore("LOGIN_SUPERUSER");
}
export function getMenuList() {
  return getStore("LOGIN_MENULIST");
}
export function getAuthToken() {
  return getStore("AUTH_TOKEN");
}
export function getChain() {
    return getStore("CHAIN");
}
